import { Step } from 'react-joyride';

export const arenaShopTourSteps: Step[] = [
  {
    target: '.tab-bar',
    content: 'Welcome to the Arena Shop! Here you can spend your Blood Gems on powerful rewards.',
    disableBeacon: true,
    placement: 'bottom',
    title: 'Arena Shop',
  },
  {
    target: '.status-frame:nth-child(2)',
    content: 'This shows your current Blood Gem balance. You earn Blood Gems by participating in Arena battles.',
    placement: 'bottom-start',
    title: 'Blood Gems',
  },
  {
    target: '.ExpandableCardGrid',
    content: 'These are the rewards you can purchase with your Blood Gems. Click on a card to see more details.',
    placement: 'top',
    title: 'Rewards',
  },
  {
    target: '.lb-button .bg-100',
    content: 'Click this button to purchase the reward with your Blood Gems.',
    placement: 'top',
    title: 'Purchase',
  },
]; 